<!-- 上月用水量排名 -->
<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">上月用水量排名</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div class="chart-details" @click="openModal">
          <img src="~@/assets/bigusers/largeScreen/details.png" title="更多" />
          <a-modal title="上月用水量前100排名" :dialog-style="{ top: '100px' }" :width="600" v-model="detailsVisible"
            :footer="null" :mask="false">
            <template #closeIcon>
              <svg width="15" height="15" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
                style="color: #1055cf;">
                <path
                  d="M17.32,14.99L29.54,2.78c.62-.62,.62-1.63,0-2.25l-.07-.07c-.62-.62-1.63-.62-2.25,0L15.01,12.69,2.79,.46C2.17-.15,1.16-.15,.54,.46l-.07,.07C-.16,1.15-.16,2.16,.47,2.78L12.69,14.99,.47,27.21c-.62,.62-.62,1.63,0,2.25l.07,.07c.62,.62,1.63,.62,2.25,0l12.21-12.21,12.21,12.21c.62,.62,1.63,.62,2.25,0l.07-.07c.62-.62,.62-1.63,0-2.25l-12.21-12.21Z"
                  fill="currentColor" />
              </svg>
            </template>
            <div class="modal-content">
              <div class="div-button">
                <a-row :gutter="16">
                  <a-col :md="4" :sm="12" v-for="(item, index) in modalButtonType" :key="index">
                    <div class="modal-button disable-text-selection"
                      :class="{ 'active-button': selectedButton === index }" @click="getModalData(index)">
                      {{ item }}
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div class="div-table">
                <a-table :columns="columns" :data-source="dataSource" style="height: 431px;" :pagination="false">
                  <template slot="index" slot-scope="text, record, index">
                    <span>{{ current == 1 ? index + 1 : index + 1 + (current - 1) * 10 }}</span>
                  </template>

                </a-table>
                <div class="pagination-right">
                  <a-pagination :current="current" :page-size="pageSize" :total="total" :item-render="customItemRender"
                    @change="onPageChange" class="custom-pagination" :show-title="false" />
                </div>
              </div>
            </div>
          </a-modal>
        </div>

        <div class="chart-inner" v-for="(item, index) in hospitalData" :key="index">
          <div class="progress-item">
            <div class="progress-badge">{{ index + 1 }}</div>
            <div class="progress-content">
              <div class="progress-label">{{ item.name }}</div>
              <div class="progress-value">{{ item.value }}m³</div>
              <a-progress :percent="item.percent" status="active" :show-info="false" :strokeWidth=5
                class="custom-progress" />
            </div>
          </div>
        </div>
      </div>
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>
<script>

const columns = [
  {
    title: '排名',
    dataIndex: 'index',
    align: 'center', // 居中
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    align: 'center',
    ellipsis: true
  },
  {
    title: '用户编码',
    dataIndex: 'userCode',
    align: 'center',
    ellipsis: true
  },
  {
    title: '用水性质',
    dataIndex: 'waterTypeName',
    align: 'center',
    ellipsis: true
  },
  {
    title: '用户地址',
    dataIndex: 'userAddress',
    align: 'center',
    ellipsis: true
  },
  {
    title: '上月用水量',
    dataIndex: 'waterConsumption',
    align: 'center',
    ellipsis: true
  }
];

export default {
  name: 'RightRanking',
  data () {
    return {
      rankingUrl: '/smart-water-major-users/major/users/user/user/order/waterconsumption/desc',
      hospitalData: [

      ],
      columns,
      detailsVisible: false,
      modalButtonType: ['居民用水', '非居民用水', '特种用水', '其他'],
      selectedButton: 0, // 默认选中第一个按钮
      current: 1,      // 当前页，必须是数字
      pageSize: 10,    // 每页条数，必须是数字
      total: 100,
      dataSource: []
    }
  },
  mounted () {
    this.initChart();
  },
  methods: {
    async initChart () {
      let params = {
        page: this.current,
        limit: this.pageSize,
        orderType: 'desc'
      }
      this.hospitalData = await this.getRankingData(params);
    },
    getRankingData (params) {
      return this.$http.get(this.rankingUrl, {
        params
      }).then((res) => {
        let list = [];
        // 以第一个项目（res.data[0]）的用水量作为100%标准
        const standardValue = res.data.list[0] ? Number(res.data.list[0].waterConsumption) : 1;


        this.total = Number(res.data.total);
        if (res.data.list && res.data.list.length > 0) {
          res.data.list.forEach(item => {
            list.push({
              ...item,
              // 为图表保留这些字段
              name: item.userName,
              value: Number(item.waterConsumption).toFixed(2),
              percent: standardValue > 0 ? (Number(item.waterConsumption) / standardValue) * 100 : 0
            })
          })
        }
        return list;
      })
    },
    //打开
    openModal () {
      this.detailsVisible = true
      this.getModalData(0);
    },
    async getModalData (index) {
      this.dataSource = [];
      // 只有当 index 有值时才赋值
      if (index !== undefined) {
        this.selectedButton = index;
      }
      let params = {
        page: this.current,
        limit: this.pageSize,
        orderType: 'desc',
        waterType: this.selectedButton + 1
      }
      this.dataSource = await this.getRankingData(params);
    },
    customItemRender (current, type, originalElement) {
      if (type === 'prev') {
        return <img src={require('@/assets/bigusers/largeScreen/left-arrow.png')} style="width:18px;height:18px;" />
      }
      if (type === 'next') {
        return <img src={require('@/assets/bigusers/largeScreen/right-arrow.png')} style="width:18px;height:18px;" />
      }
      return originalElement;
    },
    onPageChange (page) {
      this.current = page;
      this.getModalData();
    },
  }
}
</script>
<style lang="less" scoped>
.mainWarp {
  height: 326px;
  width: 412px;

  position: relative;


  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .chart-container {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    /* 确保在底层 */
  }

  .top {
    flex: 0 0 60px;
    /* 固定高度 14% */
    background: url(~@/assets/bigusers/largeScreen/topBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .middle {
    flex: 0 0 70%;
    /* 固定高度 60% */
    background: url(~@/assets/bigusers/largeScreen/middleBox.png) repeat;
    background-size: 100% auto;
    /* 水平拉伸，垂直平铺 */
  }

  .bottom {
    flex: 0 0 60px;
    /* 固定高度 20% */
    background: url(~@/assets/bigusers/largeScreen/bottomBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .img-title {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;
    /* 确保标题在最上层 */

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}

.chart-container {

  .chart-details {
    position: absolute;
    top: -20px;
    right: 20px;
    width: 50px;
    height: 20px;
    cursor: pointer;
  }

  // 主容器样式
  .chart-inner {
    height: 5%;
    display: flex;
    margin-top: 15px;

    .progress-item {
      height: 10%;
      width: 100%;
      display: flex;
      margin: 10px 0;
      align-items: center;

      .progress-badge {
        width: 20px;
        height: 20px;
        background: #107ff0;
        text-align: center;
        border-radius: 50%;
        margin: 0 20px;
        color: white;
        flex-shrink: 0;
      }

      .progress-content {
        width: 80%;
        position: relative;
        padding-top: 12px; // 为绝对定位元素预留空间

        .progress-label {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 12px;
          color: #a8d8f1;
        }

        .progress-value {
          position: absolute;
          top: -2px;
          right: 0;
          font-size: 15px;
          color: #a8d8f1;
        }

        .custom-progress {

          // 覆盖Ant Design默认样式

        }
      }
    }
  }
}

/deep/ .ant-modal-header {
  padding: 0;
  border: none
}

/deep/ .ant-modal-title {
  color: #0faae3;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

/deep/ .ant-modal-content {
  position: relative;
  background: transparent;
  padding-top: 30px;
  /* 顶部背景高度 */
  padding-bottom: 30px;
  /* 底部背景高度 */

  /* 顶部背景（伪元素） */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: url(~@/assets/bigusers/largeScreen/modalTop.png) no-repeat;
    background-size: 100% 100%;
  }

  /* 中部背景（实际内容区域） */
  &>div {
    background: url(~@/assets/bigusers/largeScreen/modalMiddle.png) repeat-y;
    background-size: 100% auto;
    height: 100%;
  }

  /* 底部背景（伪元素） */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: url(~@/assets/bigusers/largeScreen/modalBottom.png) no-repeat;
    background-size: 100% 100%;
  }
}

/deep/.ant-progress-inner {
  background-color: transparent;
}

.modal-button {
  width: 92px;
  height: 32.5px;
  background: url(~@/assets/bigusers/largeScreen/modalButton.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 7px;
  font-weight: bold;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

.modal-button:hover,
.modal-button.active-button {
  background: url(~@/assets/bigusers/largeScreen/modalButtonHighlight.png) no-repeat;
  background-size: 100% 100%;
}

.div-table {
  margin-top: 10px;
}

::v-deep .ant-modal-body {
  padding-bottom: 0;
}

/* 表头样式 */
::v-deep .ant-table-thead>tr>th {
  background: rgba(32, 94, 250, 0.5) !important;
  /* 深蓝色背景 */
  color: #fff !important;
  /* 白色字体 */
  font-weight: bold;
  border: none;
  padding: 10px;
}

/* 表格内容样式 */
::v-deep .ant-table-tbody>tr>td {
  background: rgba(22, 51, 102, 0.1) !important;
  /* 内容区深蓝色 */
  color: #fff !important;
  /* 白色字体 */
  border: none;
}

/* 去除表格边框 */
::v-deep .ant-table {
  background: transparent !important;
}

::v-deep .ant-table-tbody>tr>td {
  border-top: 6px solid rgba(16, 30, 58, 0.7) !important;
  /* 间隔色，和背景色接近即可 */
  background: rgba(157, 184, 252, 0.1) !important;
  color: #fff !important;
  padding: 6px 10px;
}

/* 去掉最后一行的分隔线 */
::v-deep .ant-table-tbody>tr:last-child>td {
  border-bottom: none !important;
}

.pagination-right {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  /* 距离表格底部的间距，可调整 */
}

::v-deep .custom-pagination .ant-pagination-item {
  background: transparent !important;
  border: none !important;
  color: #2b7cff !important;
  /* 普通数字蓝色 */
  font-size: 12px;
  box-shadow: none !important;
  transition: color 0.2s;
  font-family: 'DIN Alternate', 'Microsoft YaHei', Arial, sans-serif;
}

::v-deep .custom-pagination .ant-pagination-item-active {
  color: #6ffcff !important;
  /* 当前页高亮蓝色 */
  font-weight: bold;
  background: none !important;
  border: none !important;
  text-shadow: 0 0 8px #3cf6ff, 0 0 2px #3cf6ff;
  min-width: 16px;
}

::v-deep .custom-pagination .ant-pagination-item a {
  color: inherit !important;
  background: none !important;
}

::v-deep .custom-pagination .ant-pagination-item-ellipsis {
  color: #2b7cff !important;
  font-size: 18px;
}

::v-deep .custom-pagination .ant-pagination-prev .ant-pagination-item-link,
::v-deep .custom-pagination .ant-pagination-next .ant-pagination-item-link {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ant-table-placeholder {
  display: none !important;
}
</style>